import { DevelopusSnackbarContextType } from './DevelopusSnackbarContext'
import { DevelopusSnackbarReducerType } from './developusSnackbar-reducer'

class DevelopusSnackbarActions {
  constructor(context: DevelopusSnackbarContextType) {
    this.context = context
  }

  readonly context: DevelopusSnackbarContextType

  showSnackbar(message: string): void {
    this.context.dispatch({
      type: DevelopusSnackbarReducerType.OPEN,
    })

    this.context.dispatch({
      type: DevelopusSnackbarReducerType.SET_MESSAGE,
      payload: message,
    })
  }

  hideSnackbar(): void {
    this.context.dispatch({
      type: DevelopusSnackbarReducerType.CLOSE,
    })

    this.context.dispatch({
      type: DevelopusSnackbarReducerType.SET_MESSAGE,
      payload: '',
    })
  }
}

export default DevelopusSnackbarActions
